/**
 * DetailBackground component
 */
import AccentMask from '@components/atoms/mask/accentMask';
import Container from '@components/atoms/container/detailBackgroundContainer';
import ContentMask from '@components/atoms/mask/sliderMask';
import DetailMask from '@components/atoms/mask/detailMask';

/**
 * This component displays the background and masks of the detail page.
 */
export default function DetailBackground() {
  return (
    <Container>
      <ContentMask />
      <DetailMask />
      <AccentMask />
    </Container>
  );
}
